import { render, staticRenderFns } from "./LastStockUpdate.vue?vue&type=template&id=1d0ce1ee&scoped=true&"
import script from "./LastStockUpdate.vue?vue&type=script&lang=js&"
export * from "./LastStockUpdate.vue?vue&type=script&lang=js&"
import style0 from "./LastStockUpdate.vue?vue&type=style&index=0&id=1d0ce1ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0ce1ee",
  null
  
)

export default component.exports